var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.894 21.77h9.446v5.024h-5.813c.096 1.437.146 2.77.241 4.206h-4.89v-4.155H8.062c0-1.64-.193-3.28.098-4.82.146-.82 1.018-1.538 1.55-2.255 1.842-2.303 3.7-4.593 5.57-6.872.728-.873 1.455-1.693 2.278-2.667h-9.06V5.207h5.38V1h4.697v4.102h5.862c0 1.692.194 3.333-.097 4.872-.146.82-1.017 1.54-1.598 2.257a692.146 692.146 0 0 1-5.57 6.872c-.732.913-1.491 1.802-2.278 2.667z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZec);
export default __webpack_public_path__ + "static/media/ZEC.48576c9892dbead15c50719e39542c3b.svg";
export { ForwardRef as ReactComponent };